import moment from 'moment-timezone';
import {
  IDENTITY_PRESETS_REQUEST,
  IDENTITY_PRESETS_FAILURE,
  IDENTITY_PRESETS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function identityPresetsRequest() {
  return {
    type: IDENTITY_PRESETS_REQUEST,
  };
}

function identityPresetsSuccess(data, token = null) {
  return {
    type: IDENTITY_PRESETS_SUCCESS,
    payload: {
      data: data || [],
      token,
    },
  };
}

function identityPresetsError(message) {
  return {
    type: IDENTITY_PRESETS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchIdentityPresets(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(identityPresetsRequest());
    if (!fresh) {
      let identityPresetsData = {};
      try {
        identityPresetsData = JSON.parse(getItem(`${config.get('appName')}.identityPresets`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !identityPresetsData.data ||
        config.get('version') !== identityPresetsData.version ||
        moment().isAfter(moment(identityPresetsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(identityPresetsSuccess(identityPresetsData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM('/identity_presets/', {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.identityPresets`, JSON.stringify({
            data: data || [],
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(identityPresetsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, identityPresetsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/identityPresets.js